import React from 'react';
import { IonIcon } from '@ionic/react';
import './GridStatus.css';

type Props = {
  tone: 'success' | 'warning' | 'neutral';
  icon: string;
  children: React.ReactNode;
};

const GridStatus: React.FC<Props> = ({ tone, icon, children }) => (
  <span className={`xeguei-grid-status xeguei-grid-status--${tone}`}>
    <IonIcon icon={icon} aria-hidden="true" />
    <span>{children}</span>
  </span>
);

export default GridStatus;
